/**
 * @Descripttion:
 * @version: 正则校验规则合集
 * @Author: dengyao
 * @Date: 2023-11-28 15:23:45
 * @LastEditors: sueRimn
 * @LastEditTime: 2023-11-28 15:44:21
 */
import { lang } from './index'
import type { Rule } from 'ant-design-vue/es/form'
const regSpecial = /[\\:*?<>|\]\[]/
const regEmoj =
  /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/
const regNumber = /^[0-9]*$/
const regText = /[\\-]/g
const negativeText = /[^\-?\d][^0-9.]/g
/**包牌号 */
export const BAG_NUM = /^(([FLEfle]\d{8})|([Bb]\d{9}))$/
/**Shopee运单号 */
export const SHOPEE_BILLNO = /^62\d{13}$/
/**普通运单号 */
export const WAY_BILL = /^6\d{11,14}$/
/**MPS主单号 */
export const MPS_NUM_MAIN = /^67\d{10}$/
/**MPS子单号 */
export const MPS_NUM_SUB = /^67\d{10}-\d{1,9}$/

/**手机号 6-15位数字 */
export const MOBILE_REG = /^[0-9]{6,15}$/
// 只能输入0/62/+62开头7到14位数字
export const PhoneNumber = /^(0|62|\+62)\d{7,14}$/
/**密码 字母数字组合8 - 20位 */
export const PWD_REG = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,20}$/
/**手机号中间四位脱敏 , 前置60 第五位开始加密*/
export const ENCRYPT_PHONE_REG = /(\d{4})\d*(\d{4})/
/** 用户名+@+网站域名 */
export const EMAIL_REG = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
/**金额正则 */
export const PRICE_REG = /^([1-9]\d{0,9}|0)(\.\d{1,2})?$/
/**1-10位大写字母/数字 */
export const tenNumber = /^[A-Z0-9]{1,10}$/
// 必须包含 大写字母、小写字母、数字、特殊字符，且 8-20 个字符 
const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[_!@#$%^&*`~()-+=])[A-Za-z\d_!@#$%^&*`~()-+=]{8,20}$/;
/**
 * 获取自定义校验promise结果
 * @param regResult 匹配完成的结果
 * @param text 提示
 * @returns promise
 */
const getValidtor = (regResult: (val: string) => boolean, text: string) => (_: any, value: string) => {
  if (value && regResult(value)) return Promise.reject(lang(text))
  return Promise.resolve()
}

type regType = (val?: string) => Record<string, any>
/**必填 */
export const requireText: regType = (text) => ({
  required: true,
  message: lang(text || '此项不能为空'),
  trigger: ['change', 'blur']
})
/**
 * 主要用于密码验证，确保密码长度为8-20位，且必须包含大写字母、小写字母、数字和特殊字符
 * @param text 可选参数，用于定制验证失败时的错误信息，默认为'密码长度8-20位，必须包含大写字母、小写字母、数字、特殊字符'
 */
export const patternText: regType = (text?: string) => ({
  validator: getValidtor((val) => !pattern.test(val), lang(text || '密码长度8-20位，必须包含大写字母、小写字母、数字、特殊字符')),
  trigger: ['change', 'blur']
})
/** 包牌号 */
export const bagNum: regType = (text) => ({
  validator: getValidtor((val) => !BAG_NUM.test(val), text || '请输入正确的包牌号')
})
/** 特殊字符 */
export const specialText: regType = (text) => ({
  validator: getValidtor((val) => regSpecial.test(val), text || '不允许输入特殊字符')
})
/**emoj表情 */
export const emoj: regType = (text) => ({
  validator: getValidtor((val) => regEmoj.test(val), text || '不能存在emoj表情符！')
})
/**emoj表情 特殊字符 */
export const emojAdSpecialText: regType = (text) => ({
  validator: getValidtor((val) => regEmoj.test(val) || regSpecial.test(val), text || '不能存在emoj表情符和特殊字符！')
})
/**数字 */
export const NumberText: regType = (text) => ({
  validator: getValidtor((val) => !regNumber.test(val), text || '请输入数字')
})

/**手机号 */
export const mobileReg: regType = (text) => ({
  validator: getValidtor((val) => !MOBILE_REG.test(val), text || '手机号格式不正确'),
  trigger: ['change', 'blur']
})
/**手机号 6-15位数字 */
export const PhoneNumberReg: regType = (text) => ({
  validator: getValidtor((val) => !PhoneNumber.test(val), text || '只能输入0/62/+62开头7到14位数字'),
  trigger: ['change', 'blur']
})
/**密码 */
export const pwdReg: regType = (text) => ({
  validator: getValidtor((val) => !PWD_REG.test(val), text || '密码长度8-20位，包含大小写字母数字等类型中两种')
})

/**体积校验 */
export const checkVolume = (e: any, volume: Record<string, 'len | width | height'>) => {
  if (volume.len && volume.width && volume.height) {
    return Promise.resolve()
  }
  return Promise.reject(new Error(lang('请输入体积')))
}
/**邮箱 */
export const emailReg: regType = (text) => ({
  validator: getValidtor((val) => !EMAIL_REG.test(val), text || '邮箱格式不正确'),
  trigger: ['change', 'blur']
})
/**邮编 用户输入小写字母，除字母和数字外，其他字符无法输入。*/
export const postCodeReg: regType = (text) => ({
  validator: getValidtor((val) => !/[A-Z\d]{1,10}/g.test(val), text || '1-10位大写字母/数字')
})

/** 长宽高体积之和不超过300*/
export const volumeReg: regType = (text) => ({
  validator: getValidtor((val: any) => val.len + val.width + val.height > 300, text || '三边之和不超过300cm')
})
/** 输入一个必须全输入*/
export const volumeAllValReg: regType = (text) => ({
  validator: getValidtor((val: any) => {
    const len = Object.values(val).filter((_) => _).length
    return len === 1 || len === 2
  }, text || '补全长宽高')
})
/** 金额*/
export const priceReg: regType = (text) => ({
  validator: getValidtor((val: any) => PRICE_REG.test(val), text || '金额有误')
})

// 经度范围
export const longitudeRange = (rule: Rule, value: string) => {
  if (value.indexOf('.') !== -1) {
    if (Number(value)) {
      if (value.split('.')[1].length > 8) {
        return Promise.reject(new Error(lang('小数点后保留8位')))
      }
    }
  } else {
    return Promise.reject(new Error(lang('请输入正确的经度')))
  }
  if (Number(value) > 180 || Number(value) < -180) {
    return Promise.reject(new Error(lang('经度应在-180.00000000到180.00000000之间')))
  } else {
    return Promise.resolve()
  }
}

// 纬度范围
export function latitudeRange(rule: Rule, value: string) {
  if (value.indexOf('.') !== -1) {
    if (Number(value)) {
      if (value.split('.')[1].length > 8) {
        return Promise.reject(new Error(lang('小数点后保留8位')))
      }
    }
  } else {
    return Promise.reject(new Error(lang('请输入正确的值')))
  }
  if (Number(value) > 90.0 || Number(value) < -90.0) {
    return Promise.reject(new Error(lang('纬度应在-90.00000000到90.00000000')))
  } else {
    return Promise.resolve()
  }
}
